import { colors } from '@vfit/shared/themes';

export const getButtonStyle = (variant?: string) => {
  let buttonStyle = {};

  switch (variant) {
    case 'primary':
      buttonStyle = {
        buttonColor: `${colors.$e60000}`,
        hoverColor: `${colors.$bd0000}`,
        clickColor: `${colors.$a10000}`,
        labelColor: `${colors.$ffffff}`,
        borderColor: `${colors.$e60000}`,
      };
      break;
    case 'secondary':
      buttonStyle = {
        buttonColor: `${colors.$ffffff}`,
        hoverColor: `${colors.$ffffff_80}`,
        clickColor: `${colors.$ffffff_60}`,
        labelColor: `${colors.$262626}`,
        borderColor: `${colors.$ffffff}`,
      };
      break;
    case 'tertiary':
      buttonStyle = {
        buttonColor: `${colors.$transparent}`,
        hoverColor: `${colors.$262626}`,
        clickColor: `${colors.$7e7e7e}`,
        labelColor: `${colors.$262626}`,
        hoverTextColor: `${colors.$ffffff}`,
        clickTextColor: `${colors.$ffffff}`,
        borderColor: `${colors.$262626}`,
      };
      break;
    default:
      buttonStyle = {
        buttonColor: `${colors.$e60000}`,
        hoverColor: `${colors.$bd0000}`,
        clickColor: `${colors.$a10000}`,
        labelColor: `${colors.$ffffff}`,
        borderColor: `${colors.$e60000}`,
      };
      break;
  }

  return buttonStyle;
};
